import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getCompaniesById: function (id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.get('companies/' + id)
  },
  getContactCompanies: function ({
    limit = 50,
    page = 1,
    status,
    client,
    sort,
    lang,
    filterByDate,
    estCardStatus,
    eChannelStatus,
    officeStatus,
    formedIn,
    expireStatus
  }) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (expireStatus) query.push(`expireSort=${expireStatus}`)
    if (filterByDate) query.push(filterByDate)
    if (status) query.push(`status[]=${status}`)
    if (estCardStatus) query.push(`estCard.expireStatus[]=${estCardStatus}`)
    if (eChannelStatus) query.push(`eChannel.expireStatus[]=${eChannelStatus}`)
    if (officeStatus) query.push(`officeAddress.expireStatus[]=${officeStatus}`)
    if (sort) query.push(`sort[]=${sort}`)
    if (client) query.push(`client[]=${client}`)
    if (formedIn) query.push(`formedIn[]=${formedIn}`)
    if (lang) query.push(lang)
    return instCred.get('clientcompanies?' + query.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/Company/api.js